/**
 * InfinitSales - Leads Service (contato por ID)
 *
 * Um lead e a PESSOA; pode ter N numeros de WhatsApp. Endpoints /api/leads/*,
 * todos gated por LEAD_MODEL_ENABLED no backend (404 com a flag off — o front
 * gateia antes via useFeatureFlags.lead_model). Usado pelo modal de vincular
 * numeros ("este numero e a mesma pessoa").
 */
import api from './api';

const leadsService = {
  /** Resolve (canal, numero) -> lead (cria se nao existir). Retorna
   *  { data: { lead_id, identities:[{channel, ref, external_id, primary}] } }. */
  async resolve(channel, number) {
    const res = await api.post('/api/leads/resolve', { channel, number });
    return res.data;
  },

  /** Qual lead JA tem este numero? (nao cria). Retorna
   *  { data: { found, lead_id?, display_name?, identities? } }. */
  async search(phone, channel = 'wa_personal') {
    const res = await api.get(
      `/api/leads/search?phone=${encodeURIComponent(phone)}&channel=${encodeURIComponent(channel)}`
    );
    return res.data;
  },

  async get(leadId) {
    const res = await api.get(`/api/leads/${encodeURIComponent(leadId)}`);
    return res.data;
  },

  /** Vincula um 2o numero a um lead EXISTENTE ("mesma pessoa"). 409 se o numero
   *  ja pertence a algum lead. */
  async link(leadId, channel, number) {
    const res = await api.post(`/api/leads/${encodeURIComponent(leadId)}/link`, {
      channel,
      number,
    });
    return res.data;
  },

  /** Remove um numero do lead (corrige vinculo errado). Mantem >=1 identidade. */
  async unlink(leadId, channel, number) {
    const res = await api.post(`/api/leads/${encodeURIComponent(leadId)}/unlink`, {
      channel,
      number,
    });
    return res.data;
  },
};

export default leadsService;
